module.exports = __webpack_public_path__ + "media/assets/back-d9c01095227f8b22e2d1ce7e0b0942ab.svg";